<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'operators.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="operatorsGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'OperatorsGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        },
        'operator_group_id': {
          type: 'number'
        }
      },
      url: 'operators',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      },{
        api: 'operatorGroups/lst',
        field: 'operator_group_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'le',
        title: 'LE',
        width: '80px'
      },
      {
        field: 'codle',
        title: 'CODLE',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        values:[],
        width: '180px'
      },
      {
        field: 'operator_group_id',
        title: 'Grupo Operadores',
        values:[],
        width: '180px'
      },
      {
        field: 'unidentified',
        title: 'Não Identificado',
        values: lists.yesNo,
        width: '80px'
      },
      {
        field: 'old_id',
        title: 'ID v1',
        width: '80px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('operators.edit')) {
        var route = router.resolve({
          name: 'operators.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
